<script setup lang="ts">
import type { SearchTextPart } from '../types/document.types'

defineProps<{ parts?: SearchTextPart[]; text?: string }>()
</script>

<template>
  <span v-if="parts?.length"><template v-for="(part, index) in parts" :key="index"><mark v-if="part.highlight" class="document-search-match">{{ part.text }}</mark><template v-else>{{ part.text }}</template></template></span>
  <span v-else>{{ text }}</span>
</template>

<style scoped>
.document-search-match {
  border-radius: 2px;
  background: rgba(var(--v-theme-warning), 0.28);
  color: inherit;
  font-weight: 600;
}
</style>
